var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},[_vm._t("tab")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }